import Header from './components/Header';
import HeroSection from './components/HeroSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <UpdatesSection />
        <IndexSection />
        <AppSection />
        <MediaSection />
        <CardsSection />
        <AboutSection />
        <TopicsSection />
        <CarouselSection />
        <ContactSection />
        <CommentsSection />
        <FaqSection />
        <FeaturesSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}